import(/* webpackMode: "eager" */ "/home/runner/work/App-Prod-Access-Hub/App-Prod-Access-Hub/apps/web/app/global-error.tsx")